import React, { ReactElement } from "react";
import { MemoizedValue } from "../../../helpers/memoizer";
import MultiValuesDisplay from "./MultiValuesDisplay";
import t from "../../../helpers/i18n";
import oc from "open-color";

interface MemoizedValueWithUnit {
  value: MemoizedValue;
  unit: string;
}

export interface MainValues {
  water?: {
    level?: MemoizedValueWithUnit;
    pressure?: MemoizedValueWithUnit;
    flow?: MemoizedValueWithUnit;
  };
  voltage?: {
    p1?: MemoizedValueWithUnit;
    p2?: MemoizedValueWithUnit;
    p3?: MemoizedValueWithUnit;
  };
  current?: {
    p1?: MemoizedValueWithUnit;
    p2?: MemoizedValueWithUnit;
    p3?: MemoizedValueWithUnit;
  };
}

export default function MainValueBlocks({ water, voltage, current }: MainValues): ReactElement {
  const waterValues = [];
  if (water?.level) {
    waterValues.push({
      value: water.level.value,
      unit: water.level.unit,
    });
  }
  if (water?.pressure) {
    waterValues.push({
      value: water.pressure.value,
      unit: water.pressure.unit,
    });
  }
  if (water?.flow) {
    waterValues.push({
      value: water.flow.value,
      unit: water.flow.unit,
    });
  }

  const voltageValues = [];
  if (voltage?.p1) {
    voltageValues.push({
      label: "L1",
      value: voltage.p1.value,
      unit: voltage.p1.unit,
    });
  }
  if (voltage?.p2) {
    voltageValues.push({
      label: "L2",
      value: voltage.p2.value,
      unit: voltage.p2.unit,
    });
  }
  if (voltage?.p3) {
    voltageValues.push({
      label: "L3",
      value: voltage.p3.value,
      unit: voltage.p3.unit,
    });
  }

  const currentValues = [];
  if (current?.p1) {
    currentValues.push({
      label: "L1",
      value: current.p1.value,
      unit: current.p1.unit,
    });
  }
  if (current?.p2) {
    currentValues.push({
      label: "L2",
      value: current.p2.value,
      unit: current.p2.unit,
    });
  }
  if (current?.p3) {
    currentValues.push({
      label: "L3",
      value: current.p3.value,
      unit: current.p3.unit,
    });
  }

  return (
    <div
      className="d-flex justify-content-between"
      style={{ gap: "10px", flexWrap: "wrap", marginBottom: "15px" }}
    >
      {water && (
        <MultiValuesDisplay name={t("Water", "Рідина")} color={oc.blue[7]} values={waterValues} />
      )}

      {voltage && (
        <MultiValuesDisplay
          name={t("Voltage", "Напруга")}
          color={oc.orange[5]}
          values={voltageValues}
        />
      )}

      {current && (
        <MultiValuesDisplay
          name={t("Current", "Струм")}
          color={oc.red[5]}
          values={currentValues}
        />
      )}
    </div>
  );
}
